import { render, staticRenderFns } from "./yz_wt_weituo.vue?vue&type=template&id=32659eec&scoped=true"
import script from "./yz_wt_weituo.vue?vue&type=script&lang=js"
export * from "./yz_wt_weituo.vue?vue&type=script&lang=js"
import style0 from "./yz_wt_weituo.vue?vue&type=style&index=0&id=32659eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32659eec",
  null
  
)

export default component.exports